const api_url = process.env.NODE_ENV ===  "development" ? "http://localhost:8000/api/v1" : "https://api.bsf9090.com/api/v1" ;
export default api_url;
